<template>
<div :style="themePageStyle">

  <!-- ============ TOPBAR ============ -->
  <div style="position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br);">
    <div class="container d-flex align-items-center gap-3">
      <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:32px;" /></a>
      <button class="btn btn-sm btn-link p-0" style="color:var(--fm-s,#6B6356);text-decoration:none;" @click="goBack"><i class="mdi mdi-arrow-left me-1"></i>{{ view==='create'&&orderCtx.orderId?'Back to Order':view==='detail'?'Disputes':view==='create'?'Disputes':'Home' }}</button>
      <div class="flex-fill"></div>
      <button v-if="view==='list'" class="btn btn-sm dp-btn-gold" @click="showCreate"><i class="mdi mdi-plus me-1"></i>Raise Dispute</button>
    </div>
  </div>

  <div class="container" style="padding-top:80px;padding-bottom:80px;max-width:960px;">

    <!-- ======================================================= -->
    <!-- LIST VIEW                                                -->
    <!-- ======================================================= -->
    <div v-if="view==='list'">
      <h5 style="font-weight:700;margin-bottom:20px;"><i class="mdi mdi-shield-alert me-2" style="color:#BFA164;"></i>My Disputes</h5>
      <div class="d-flex gap-2 flex-wrap mb-4" style="border-bottom:1px solid var(--fm-br);padding-bottom:12px;">
        <button v-for="t in tabs" :key="t.v" class="dp-tab" :class="{active:filter===t.v}" @click="filter=t.v;loadDisputes()">{{ t.l }}</button>
      </div>
      <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
      <div v-else-if="!disputes.length" class="text-center py-5">
        <i class="mdi mdi-shield-check" style="font-size:48px;color:#2A2A2A;"></i>
        <p class="mt-2" style="color:var(--fm-s,#6B6356);">No disputes found</p>
      </div>
      <div v-else>
        <div v-for="d in disputes" :key="d.id" class="dp-list-card" @click="openDispute(d.id)">
          <div class="d-flex align-items-start gap-3">
            <div class="dp-st-circle" :class="'dp-st-'+d.status"><i class="mdi" :class="stIcon(d.status)"></i></div>
            <div class="flex-fill" style="min-width:0;">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span style="font-size:11px;color:var(--fm-s,#6B6356);font-family:monospace;">#{{ d.dispute_number }}</span>
                <span class="dp-badge" :class="'dp-st-'+d.status">{{ fmtS(d.status) }}</span>
              </div>
              <div style="font-size:14px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ d.dispute_type ? fmtT(d.dispute_type) : 'Dispute' }}</div>
              <div style="font-size:12px;color:var(--fm-s,#6B6356);margin-top:2px;">Order: {{ d.order_number || '—' }}</div>
            </div>
            <i class="mdi mdi-chevron-right" style="color:#3A3A3A;font-size:20px;margin-top:8px;"></i>
          </div>
          <div style="font-size:11px;color:#4A4A3A;margin-top:8px;text-align:right;">{{ fmtD(d.created_at) }}</div>
        </div>
      </div>
    </div>

    <!-- ======================================================= -->
    <!-- DETAIL VIEW                                              -->
    <!-- ======================================================= -->
    <div v-if="view==='detail'">
      <div v-if="loadingDetail" class="text-center py-5"><div class="spinner-border text-warning"></div></div>
      <div v-else-if="!dispute.id" class="text-center py-5">
        <i class="mdi mdi-alert-circle" style="font-size:48px;color:#FF6B6B;"></i>
        <p class="mt-2" style="color:var(--fm-s,#6B6356);">Dispute not found</p>
      </div>
      <div v-else>
        <!-- Header -->
        <div class="dp-panel mb-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div>
              <span style="font-size:12px;color:var(--fm-s,#6B6356);font-family:monospace;">#{{ dispute.dispute_number }}</span>
              <span class="dp-badge ms-2" :class="'dp-st-'+dispute.status">{{ fmtS(dispute.status) }}</span>
            </div>
            <span style="color:var(--fm-s,#6B6356);font-size:12px;">{{ fmtD(dispute.created_at) }}</span>
          </div>
          <h5 style="font-weight:700;margin-bottom:4px;">{{ fmtT(dispute.dispute_type) }}</h5>
          <div style="color:#8A8070;font-size:13px;margin-bottom:12px;">Order: {{ dispute.order_number || '—' }}</div>
          <div style="background:var(--fm-bg2,#111);border-radius:8px;padding:14px;font-size:13px;color:var(--fm-m,#C5B898);line-height:1.6;">{{ dispute.description }}</div>
          <div v-if="dispute.desired_resolution" style="margin-top:10px;font-size:12px;color:var(--fm-s,#6B6356);">
            <strong style="color:#BFA164;">Desired Resolution:</strong> {{ dispute.desired_resolution }}
          </div>
        </div>
        <!-- Parties -->
        <div class="dp-panel mb-3">
          <h6 class="dp-panel-h"><i class="mdi mdi-account-multiple me-2"></i>Parties</h6>
          <div class="row g-2">
            <div class="col-6"><div style="font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:1px;">Raised By</div><div style="font-size:14px;font-weight:600;">{{ dispute.raised_by_name || '—' }}</div></div>
            <div class="col-6"><div style="font-size:11px;color:var(--fm-s,#6B6356);text-transform:uppercase;letter-spacing:1px;">Against</div><div style="font-size:14px;font-weight:600;">{{ dispute.against_name || '—' }}</div></div>
          </div>
        </div>
        <!-- Evidence -->
        <div class="dp-panel mb-3">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h6 class="dp-panel-h mb-0"><i class="mdi mdi-file-document-multiple me-2"></i>Evidence ({{ (dispute.evidence||[]).length }})</h6>
            <button v-if="dispute.status!=='resolved'&&dispute.status!=='closed'" class="btn btn-sm dp-btn-gold" @click="showEvidence=!showEvidence">
              <i class="mdi" :class="showEvidence?'mdi-close':'mdi-plus'" style="margin-right:4px;"></i>{{ showEvidence?'Cancel':'Add' }}
            </button>
          </div>
          <!-- Add evidence form -->
          <div v-if="showEvidence" class="dp-ev-form mb-3">
            <div class="mb-2">
              <label class="dp-lbl">Type</label>
              <div class="d-flex gap-2 flex-wrap mt-1">
                <button v-for="et in evTypes" :key="et.v" class="dp-chip" :class="{active:evForm.evidenceType===et.v}" @click="evForm.evidenceType=et.v"><i class="mdi" :class="et.i" style="margin-right:4px;"></i>{{ et.l }}</button>
              </div>
            </div>
            <div class="mb-2">
              <label class="dp-lbl">Description</label>
              <textarea v-model="evForm.description" class="dp-input" rows="2" placeholder="Describe this evidence..."></textarea>
            </div>
            <div v-if="evForm.evidenceType!=='text'" class="mb-2">
              <label class="dp-lbl">File</label>
              <input type="file" ref="evFileRef" class="dp-input dp-file-input" @change="evFileChanged" />
            </div>
            <div class="d-flex gap-2 justify-content-end">
              <button class="btn btn-sm dp-btn-muted" @click="showEvidence=false">Cancel</button>
              <button class="btn btn-sm dp-btn-gold" :disabled="evSubmitting" @click="submitEvidence">
                <span v-if="evSubmitting" class="spinner-border spinner-border-sm me-1"></span>Submit
              </button>
            </div>
          </div>
          <!-- Evidence timeline -->
          <div v-if="!(dispute.evidence||[]).length && !showEvidence" style="font-size:13px;color:#4A4A3A;text-align:center;padding:20px 0;">No evidence submitted yet</div>
          <div v-for="(ev,i) in (dispute.evidence||[])" :key="i" class="dp-ev-item">
            <div class="dp-ev-dot"></div>
            <div class="flex-fill" style="min-width:0;">
              <div class="d-flex align-items-center justify-content-between mb-1">
                <span class="dp-ev-type"><i class="mdi" :class="evIcon(ev.evidence_type)" style="margin-right:4px;"></i>{{ ev.evidence_type }}</span>
                <span style="font-size:11px;color:#4A4A3A;">{{ fmtD(ev.created_at) }}</span>
              </div>
              <div v-if="ev.content && ev.evidence_type!=='photo'" style="font-size:13px;color:#C5B898;margin-bottom:6px;">{{ ev.content }}</div>
              <div v-if="ev.file_url" style="margin-top:6px;">
                <!-- Image: inline + click to open full -->
                <div v-if="isImg(ev.file_url)" style="position:relative;display:inline-block;cursor:pointer;" @click="openFile(ev.file_url)">
                  <img :src="pu(ev.file_url)" style="max-width:100%;max-height:260px;border-radius:8px;border:1px solid #2A2A2A;display:block;" />
                  <div class="dp-ev-overlay"><i class="mdi mdi-magnify-plus-outline"></i></div>
                </div>
                <!-- Video: inline player -->
                <div v-else-if="isVid(ev.file_url)">
                  <video controls preload="metadata" style="max-width:100%;max-height:300px;border-radius:8px;border:1px solid #2A2A2A;background:#000;">
                    <source :src="pu(ev.file_url)" :type="vidType(ev.file_url)" />
                    Your browser does not support video playback.
                  </video>
                </div>
                <!-- PDF: embedded viewer -->
                <div v-else-if="isPdf(ev.file_url)">
                  <div class="dp-ev-doc-card" @click="openFile(ev.file_url)">
                    <i class="mdi mdi-file-pdf-box" style="font-size:28px;color:#FF6B6B;"></i>
                    <div>
                      <div style="font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8);">{{ fileName(ev.file_url) }}</div>
                      <div style="font-size:11px;color:var(--fm-s,#6B6356);">PDF Document &middot; Tap to view</div>
                    </div>
                    <i class="mdi mdi-open-in-new" style="color:#BFA164;font-size:18px;"></i>
                  </div>
                </div>
                <!-- Other documents -->
                <div v-else>
                  <div class="dp-ev-doc-card" @click="openFile(ev.file_url)">
                    <i class="mdi mdi-file-document" style="font-size:28px;color:#BFA164;"></i>
                    <div>
                      <div style="font-size:13px;font-weight:600;color:var(--fm-h,#F5F0E8);">{{ fileName(ev.file_url) }}</div>
                      <div style="font-size:11px;color:var(--fm-s,#6B6356);">Tap to open in new tab</div>
                    </div>
                    <i class="mdi mdi-open-in-new" style="color:#BFA164;font-size:18px;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Admin Resolve -->
        <div v-if="isAdmin && dispute.status!=='resolved' && dispute.status!=='closed'" class="dp-panel mb-3" style="border:1px solid rgba(191,161,100,.3);">
          <h6 class="dp-panel-h"><i class="mdi mdi-gavel me-2" style="color:#BFA164;"></i>Resolve Dispute</h6>
          <div class="mb-2">
            <label class="dp-lbl">Resolution</label>
            <select v-model="resolveForm.resolution" class="dp-input dp-select">
              <option value="">— Select —</option>
              <option value="full_refund">Full Refund to Buyer</option>
              <option value="partial_refund">Partial Refund</option>
              <option value="release_to_seller">Release to Seller</option>
              <option value="mutual_agreement">Mutual Agreement</option>
              <option value="dismissed">Dismissed</option>
            </select>
          </div>
          <div v-if="resolveForm.resolution==='partial_refund'" class="mb-2">
            <label class="dp-lbl">Refund Amount (KES)</label>
            <input v-model="resolveForm.refundAmount" type="number" class="dp-input" placeholder="e.g. 5000" />
          </div>
          <div class="mb-3">
            <label class="dp-lbl">Resolution Notes</label>
            <textarea v-model="resolveForm.resolutionNotes" class="dp-input" rows="3" placeholder="Explain the resolution..."></textarea>
          </div>
          <button class="btn dp-btn-gold w-100" :disabled="!resolveForm.resolution||resolving" @click="submitResolve">
            <span v-if="resolving" class="spinner-border spinner-border-sm me-1"></span>Resolve Dispute
          </button>
        </div>
        <!-- Resolved card -->
        <div v-if="dispute.status==='resolved'" class="dp-panel mb-3" style="border:1px solid rgba(80,200,120,.25);">
          <h6 class="dp-panel-h" style="color:#50C878;"><i class="mdi mdi-check-circle me-2"></i>Resolved</h6>
          <div class="dp-res-row"><span>Resolution</span><span>{{ dispute.resolution_type ? fmtT(dispute.resolution_type) : '—' }}</span></div>
          <div v-if="dispute.resolution_amount" class="dp-res-row"><span>Refund Amount</span><span style="color:#BFA164;font-weight:600;">KES {{ fN(dispute.resolution_amount) }}</span></div>
          <div v-if="dispute.resolution_notes" style="font-size:13px;color:var(--fm-m,#8A8070);margin-top:8px;padding:10px;background:var(--fm-bg2,#111);border-radius:6px;">{{ dispute.resolution_notes }}</div>
          <div style="font-size:11px;color:#4A4A3A;margin-top:8px;">Resolved {{ fmtD(dispute.resolved_at) }}</div>
        </div>
      </div>
    </div>

    <!-- ======================================================= -->
    <!-- CREATE VIEW  (card-based UI matching screenshot)         -->
    <!-- ======================================================= -->
    <div v-if="view==='create'">
      <!-- Centred icon + heading -->
      <div class="text-center mb-4">
        <div style="width:56px;height:56px;border-radius:50%;background:rgba(255,107,107,.12);display:inline-flex;align-items:center;justify-content:center;margin-bottom:10px;">
          <i class="mdi mdi-alert-circle" style="font-size:28px;color:#FF6B6B;"></i>
        </div>
        <h5 style="font-weight:700;color:#BFA164;margin-bottom:4px;">Raise a Dispute</h5>
        <div v-if="orderCtx.orderNumber" style="font-size:13px;color:var(--fm-s,#6B6356);">Order {{ orderCtx.orderNumber }}</div>
      </div>

      <!-- Order summary card -->
      <div v-if="orderCtx.listingTitle" class="dp-panel mb-4" style="max-width:580px;margin-left:auto;margin-right:auto;">
        <div class="dp-summary-row"><span>Item</span><span style="font-weight:700;">{{ orderCtx.listingTitle }}</span></div>
        <div class="dp-summary-row"><span>Amount</span><span style="font-weight:700;color:#BFA164;">KES {{ fN(orderCtx.totalAmount) }}</span></div>
        <div class="dp-summary-row" style="border-bottom:none;"><span>Other Party</span><span style="font-weight:700;">{{ orderCtx.otherParty }}</span></div>
      </div>

      <div style="max-width:580px;margin-left:auto;margin-right:auto;">
        <!-- Order ID input (shown when no order context passed) -->
        <div v-if="!orderCtx.orderId" class="mb-4">
          <label class="dp-lbl mb-1">ORDER ID <span style="color:#FF6B6B;">*</span></label>
          <input v-model="createForm.orderId" type="text" class="dp-input" placeholder="Paste the order ID here" />
        </div>

        <!-- Issue type cards (2-col grid) -->
        <label class="dp-lbl mb-2">WHAT'S THE ISSUE? <span style="color:#FF6B6B;">*</span></label>
        <div class="row g-2 mb-4">
          <div class="col-6" v-for="it in issueTypes" :key="it.v">
            <div class="dp-select-card" :class="{active:createForm.disputeType===it.v}" @click="createForm.disputeType=it.v">
              <i v-if="it.i" class="mdi" :class="it.i" style="font-size:20px;margin-bottom:4px;display:block;"></i>
              <span>{{ it.l }}</span>
            </div>
          </div>
        </div>

        <!-- Short summary -->
        <label class="dp-lbl mb-1">SHORT SUMMARY <span style="color:#FF6B6B;">*</span></label>
        <input v-model="createForm.title" type="text" class="dp-input mb-4" placeholder="e.g. Cow has visible injuries not shown in listing" />

        <!-- Description -->
        <label class="dp-lbl mb-1">DESCRIBE THE PROBLEM IN DETAIL <span style="color:#FF6B6B;">*</span></label>
        <textarea v-model="createForm.description" class="dp-input mb-4" rows="4" placeholder="Explain what happened, what you expected, and what you received. Be as specific as possible."></textarea>

        <!-- Resolution type cards -->
        <label class="dp-lbl mb-2">WHAT RESOLUTION DO YOU WANT?</label>
        <div class="row g-2 mb-4">
          <div class="col-6" v-for="rt in resolutionTypes" :key="rt.v">
            <div class="dp-select-card" :class="{active:createForm.desiredResolution===rt.v}" @click="createForm.desiredResolution=rt.v">
              <i v-if="rt.i" class="mdi" :class="rt.i" style="font-size:20px;margin-bottom:4px;display:block;"></i>
              <span>{{ rt.l }}</span>
            </div>
          </div>
        </div>

        <!-- Evidence upload zone -->
        <label class="dp-lbl mb-1">ATTACH EVIDENCE (OPTIONAL)</label>
        <div class="dp-upload-zone mb-4" @click="$refs.createFileRef.click()" @dragover.prevent @drop.prevent="onDropFiles">
          <input type="file" ref="createFileRef" multiple style="display:none;" @change="onPickFiles" />
          <i class="mdi mdi-cloud-upload" style="font-size:28px;color:#BFA164;"></i>
          <div style="font-size:13px;color:var(--fm-s,#6B6356);margin-top:4px;">Tap to upload photos or documents</div>
          <div v-if="createFiles.length" style="margin-top:8px;">
            <div v-for="(cf,i) in createFiles" :key="i" class="dp-file-pill">
              <i class="mdi mdi-file me-1"></i>{{ cf.name }}
              <i class="mdi mdi-close ms-1" style="cursor:pointer;" @click.stop="createFiles.splice(i,1)"></i>
            </div>
          </div>
        </div>

        <!-- Submit buttons -->
        <div class="d-flex gap-2 mb-4">
          <button class="btn dp-btn-muted flex-fill" @click="cancelCreate">Cancel</button>
          <button class="btn dp-btn-gold flex-fill" :disabled="!canCreate||creating" @click="submitCreate">
            <span v-if="creating" class="spinner-border spinner-border-sm me-1"></span>Submit Dispute
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- Toast -->
  <div v-if="toast" class="dp-toast" :class="toast.ok?'dp-toast-ok':'dp-toast-err'">
    <i class="mdi" :class="toast.ok?'mdi-check-circle':'mdi-alert-circle'" style="margin-right:6px;"></i>{{ toast.msg }}
  </div>
</div>
</template>

<script>
import { execute, flocker } from "@/api";

export default {
  name: 'DisputePage',
  data() {
    return {
      darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',

      view: 'list',
      loading: false,
      loadingDetail: false,
      filter: '',
      disputes: [],
      dispute: {},
      tabs: [
        { l: 'All', v: '' },
        { l: 'Open', v: 'open' },
        { l: 'Resolved', v: 'resolved' },
        { l: 'Closed', v: 'closed' }
      ],
      issueTypes: [
        { v: 'item_not_as_described', l: 'Not as Described', i: '' },
        { v: 'item_not_received', l: 'Not Delivered', i: '' },
        { v: 'health_issue', l: 'Health Issue', i: 'mdi-hospital-box' },
        { v: 'transport_damage', l: 'Transport Damage', i: '' },
        { v: 'quality_issue', l: 'Quality Issue', i: '' },
        { v: 'payment_issue', l: 'Payment Issue', i: 'mdi-credit-card-refund' },
        { v: 'fraud', l: 'Fraud / Scam', i: 'mdi-alert-decagram' },
        { v: 'other', l: 'Other', i: 'mdi-dots-horizontal-circle' }
      ],
      resolutionTypes: [
        { v: 'full_refund', l: 'Full Refund', i: 'mdi-cash-refund' },
        { v: 'partial_refund', l: 'Partial Refund', i: 'mdi-credit-card-refund' },
        { v: 'replacement', l: 'Replacement', i: 'mdi-swap-horizontal' },
        { v: 'other', l: 'Other', i: 'mdi-dots-horizontal-circle' }
      ],
      evTypes: [
        { v: 'photo', l: 'Photo', i: 'mdi-camera' },
        { v: 'document', l: 'Document', i: 'mdi-file-document' },
        { v: 'video', l: 'Video', i: 'mdi-video' },
        { v: 'text', l: 'Text Note', i: 'mdi-text' }
      ],
      // Order context passed from OrderDetail via query params
      orderCtx: { orderId: '', orderNumber: '', listingTitle: '', totalAmount: '', otherParty: '' },
      // Create form
      createForm: { orderId: '', disputeType: '', title: '', description: '', desiredResolution: '' },
      createFiles: [],
      creating: false,
      // Evidence form
      showEvidence: false,
      evForm: { evidenceType: 'photo', description: '' },
      evFile: null,
      evSubmitting: false,
      // Resolve form
      resolveForm: { resolution: '', resolutionNotes: '', refundAmount: '' },
      resolving: false,
      // Toast
      toast: null,
      toastTimer: null,
      // User
      userId: '',
      userRole: ''
    };
  },
  computed: {
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    isAdmin() { return this.userRole === 'admin'; },
    effectiveOrderId() { return this.orderCtx.orderId || this.createForm.orderId || ''; },
    canCreate() { return this.effectiveOrderId && this.createForm.disputeType && this.createForm.title && this.createForm.description; }
  },
  mounted() {
    // Apply global theme
    var t=localStorage.getItem('flockr_theme')||'dark';window.__flockrSetTheme(t);

    this.userId = sessionStorage.getItem('userId') || '';
    this.userRole = sessionStorage.getItem('userRole') || '';
    if (!this.userId) { this.$router.push('/login'); return; }
    var q = this.$route.query;
    if (q.orderId) {
      // Coming from OrderDetail "Raise Dispute" button
      this.orderCtx.orderId = q.orderId;
      this.orderCtx.orderNumber = q.orderNumber || '';
      this.orderCtx.listingTitle = q.listingTitle || '';
      this.orderCtx.totalAmount = q.totalAmount || '';
      this.orderCtx.otherParty = q.otherParty || '';
      this.view = 'create';
    } else if (q.id) {
      this.openDispute(q.id);
    } else {
      this.loadDisputes();
    }
  },
  methods: {
    fN(v) { return v ? Number(v).toLocaleString() : '0'; },
    fmtD(d) { return d ? new Date(d).toLocaleDateString('en-KE', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' }) : ''; },
    pu(p) { return p && p.startsWith('http') ? p : (flocker.replace('/index.php','') + '/' + p); },
    fmtS(s) { return (s||'').replace(/_/g,' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); }); },
    fmtT(t) { return (t||'').replace(/_/g,' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); }); },
    isImg(url) { if (!url) return false; var ext = url.split('.').pop().toLowerCase(); return ['jpg','jpeg','png','gif','webp'].indexOf(ext) !== -1; },
    isVid(url) { if (!url) return false; var ext = url.split('.').pop().toLowerCase(); return ['mp4','mov','avi','webm','mkv'].indexOf(ext) !== -1; },
    isPdf(url) { if (!url) return false; return url.split('.').pop().toLowerCase() === 'pdf'; },
    vidType(url) { var m = { mp4:'video/mp4', mov:'video/mp4', webm:'video/webm', avi:'video/x-msvideo', mkv:'video/x-matroska' }; var ext = (url||'').split('.').pop().toLowerCase(); return m[ext] || 'video/mp4'; },
    fileName(url) { if (!url) return 'File'; var parts = url.split('/'); return decodeURIComponent(parts[parts.length - 1]); },
    openFile(url) { window.open(this.pu(url), '_blank'); },
    stIcon(s) { var m = { open:'mdi-alert-circle-outline', resolved:'mdi-check-circle', closed:'mdi-close-circle' }; return m[s] || 'mdi-shield-alert'; },
    evIcon(t) { var m = { photo:'mdi-camera', document:'mdi-file-document', video:'mdi-video', text:'mdi-text' }; return m[t] || 'mdi-file'; },

    goBack() {
      if (this.view === 'detail') { this.view = 'list'; this.dispute = {}; this.loadDisputes(); }
      else if (this.view === 'create' && this.orderCtx.orderId) { this.$router.push('/orders/' + this.orderCtx.orderId); }
      else if (this.view === 'create') { this.view = 'list'; this.loadDisputes(); }
      else { this.$router.push('/'); }
    },
    cancelCreate() {
      if (this.orderCtx.orderId) { this.$router.push('/orders/' + this.orderCtx.orderId); }
      else { this.view = 'list'; this.loadDisputes(); }
    },
    showCreate() {
      this.orderCtx = { orderId:'', orderNumber:'', listingTitle:'', totalAmount:'', otherParty:'' };
      this.createForm = { orderId:'', disputeType:'', title:'', description:'', desiredResolution:'' };
      this.createFiles = [];
      this.view = 'create';
    },
    showToast(msg, ok) {
      clearTimeout(this.toastTimer);
      this.toast = { msg: msg, ok: ok };
      this.toastTimer = setTimeout(function(){ this.toast = null; }.bind(this), 3500);
    },
    onPickFiles(e) {
      var files = Array.from(e.target.files || []);
      for (var i = 0; i < files.length; i++) this.createFiles.push(files[i]);
    },
    onDropFiles(e) {
      var files = Array.from(e.dataTransfer.files || []);
      for (var i = 0; i < files.length; i++) this.createFiles.push(files[i]);
    },

    // ---- API ----
    async loadDisputes() {
      this.loading = true;
      try {
        var f = new FormData();
        f.append('function', 'getDisputes');
        f.append('userId', this.userId);
        if (this.filter) f.append('status', this.filter);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) this.disputes = (r.data.data && r.data.data.disputes) || [];
        else this.disputes = [];
      } catch (e) { console.error(e); this.disputes = []; }
      this.loading = false;
    },

    async openDispute(id) {
      this.view = 'detail';
      this.loadingDetail = true;
      this.dispute = {};
      this.showEvidence = false;
      this.resolveForm = { resolution:'', resolutionNotes:'', refundAmount:'' };
      try {
        var f = new FormData();
        f.append('function', 'getDispute');
        f.append('disputeId', id);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) this.dispute = (r.data.data && r.data.data.dispute) || {};
        else this.showToast(r.data.message || 'Failed to load dispute', false);
      } catch (e) { console.error(e); this.showToast('Error loading dispute', false); }
      this.loadingDetail = false;
    },

    async submitCreate() {
      this.creating = true;
      try {
        var f = new FormData();
        f.append('function', 'createDispute');
        f.append('orderId', this.effectiveOrderId);
        f.append('raisedById', this.userId);
        f.append('disputeType', this.createForm.disputeType);
        f.append('title', this.createForm.title);
        f.append('description', this.createForm.description);
        f.append('desiredResolution', this.createForm.desiredResolution);
        for (var i = 0; i < this.createFiles.length; i++) {
          f.append('file_' + i, this.createFiles[i]);
        }
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.showToast('Dispute raised successfully', true);
          this.view = 'list';
          this.loadDisputes();
        } else {
          this.showToast(r.data.message || 'Failed to create dispute', false);
        }
      } catch (e) { console.error(e); this.showToast('Error creating dispute', false); }
      this.creating = false;
    },

    evFileChanged(e) { this.evFile = e.target.files[0] || null; },

    async submitEvidence() {
      if (!this.evForm.description && this.evForm.evidenceType === 'text') { this.showToast('Description is required for text evidence', false); return; }
      if (this.evForm.evidenceType !== 'text' && !this.evFile && !this.evForm.description) { this.showToast('Please add a file or description', false); return; }
      this.evSubmitting = true;
      try {
        var f = new FormData();
        f.append('function', 'addDisputeEvidence');
        f.append('disputeId', this.dispute.id);
        f.append('submittedBy', this.userId);
        f.append('evidenceType', this.evForm.evidenceType);
        f.append('description', this.evForm.description);
        if (this.evFile) f.append('file', this.evFile);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.showToast('Evidence added', true);
          this.showEvidence = false;
          this.evForm = { evidenceType:'photo', description:'' };
          this.evFile = null;
          await this.openDispute(this.dispute.id);
        } else {
          this.showToast(r.data.message || 'Failed to add evidence', false);
        }
      } catch (e) { console.error(e); this.showToast('Error adding evidence', false); }
      this.evSubmitting = false;
    },

    async submitResolve() {
      if (!this.resolveForm.resolution) return;
      if (this.resolveForm.resolution === 'partial_refund' && !this.resolveForm.refundAmount) { this.showToast('Enter refund amount', false); return; }
      this.resolving = true;
      try {
        var f = new FormData();
        f.append('function', 'resolveDispute');
        f.append('disputeId', this.dispute.id);
        f.append('resolvedBy', this.userId);
        f.append('resolution', this.resolveForm.resolution);
        f.append('resolutionNotes', this.resolveForm.resolutionNotes);
        if (this.resolveForm.refundAmount) f.append('refundAmount', this.resolveForm.refundAmount);
        var r = await execute(f, flocker);
        if (r.data && r.data.success) {
          this.showToast('Dispute resolved', true);
          this.resolveForm = { resolution:'', resolutionNotes:'', refundAmount:'' };
          await this.openDispute(this.dispute.id);
        } else {
          this.showToast(r.data.message || 'Failed to resolve', false);
        }
      } catch (e) { console.error(e); this.showToast('Error resolving dispute', false); }
      this.resolving = false;
    }
  }
};
</script>

<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style scoped>
/* ---- Panels ---- */
.dp-panel{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px;}
.dp-panel-h{font-size:13px;font-weight:700;color:#8A8070;text-transform:uppercase;letter-spacing:.8px;margin-bottom:12px;}

/* ---- List cards ---- */
.dp-list-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:14px 16px;margin-bottom:10px;cursor:pointer;transition:border-color .2s,background .2s;}
.dp-list-card:hover{border-color:#BFA164;background:#1A1A18;}

/* ---- Status circles ---- */
.dp-st-circle{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;}
.dp-st-circle.dp-st-open{background:rgba(255,180,60,.1);color:#FFB43C;}
.dp-st-circle.dp-st-resolved{background:rgba(80,200,120,.1);color:#50C878;}
.dp-st-circle.dp-st-closed{background:rgba(100,100,100,.1);color:var(--fm-s,#6B6356);}

/* ---- Badges ---- */
.dp-badge{font-size:10px;font-weight:700;padding:3px 8px;border-radius:20px;text-transform:uppercase;letter-spacing:.5px;}
.dp-badge.dp-st-open{background:rgba(255,180,60,.12);color:#FFB43C;}
.dp-badge.dp-st-resolved{background:rgba(80,200,120,.12);color:#50C878;}
.dp-badge.dp-st-closed{background:rgba(100,100,100,.12);color:var(--fm-s,#6B6356);}

/* ---- Tabs ---- */
.dp-tab{background:none;border:none;color:var(--fm-s,#6B6356);font-size:13px;font-weight:600;padding:6px 14px;border-radius:20px;cursor:pointer;transition:all .2s;}
.dp-tab:hover{color:var(--fm-h,#F5F0E8);}
.dp-tab.active{background:rgba(191,161,100,.15);color:#BFA164;}

/* ---- Buttons ---- */
.dp-btn-gold{background:linear-gradient(135deg,#BFA164,#D4B876);color:#0A0A0A;font-weight:600;font-size:13px;border:none;border-radius:8px;padding:8px 16px;transition:opacity .2s;}
.dp-btn-gold:hover{opacity:.9;color:#0A0A0A;}
.dp-btn-gold:disabled{opacity:.4;cursor:not-allowed;}
.dp-btn-muted{background:var(--fm-bg3,#1E1E1E);color:#8A8070;border:none;font-size:13px;border-radius:8px;padding:8px 16px;}
.dp-btn-muted:hover{background:#2A2A2A;color:var(--fm-h,#F5F0E8);}

/* ---- Inputs ---- */
.dp-lbl{display:block;font-size:12px;font-weight:600;color:var(--fm-s,#6B6356);letter-spacing:.5px;}
.dp-input{width:100%;background:var(--fm-bg1,#141414);border:1px solid #2A2A2A;border-radius:8px;padding:10px 12px;color:var(--fm-h,#F5F0E8);font-size:14px;transition:border-color .2s;}
.dp-input:focus{outline:none;border-color:#BFA164;}
.dp-input::placeholder{color:#4A4A3A;}
.dp-select{-webkit-appearance:auto;appearance:auto;}
textarea.dp-input{resize:vertical;}
.dp-file-input{padding:8px;font-size:12px;}
.dp-file-input::file-selector-button{background:#2A2A2A;color:#C5B898;border:none;border-radius:4px;padding:4px 10px;margin-right:8px;cursor:pointer;}

/* ---- Selectable cards (issue type / resolution) ---- */
.dp-select-card{background:var(--fm-bg1,#141414);border:1px solid #2A2A2A;border-radius:10px;padding:16px 12px;text-align:center;cursor:pointer;font-size:13px;font-weight:600;color:#8A8070;transition:all .2s;min-height:60px;display:flex;flex-direction:column;align-items:center;justify-content:center;}
.dp-select-card:hover{border-color:#BFA164;color:var(--fm-h,#F5F0E8);}
.dp-select-card.active{border-color:#BFA164;background:rgba(191,161,100,.08);color:#BFA164;}

/* ---- Upload zone ---- */
.dp-upload-zone{background:var(--fm-bg1,#141414);border:2px dashed #2A2A2A;border-radius:10px;padding:24px;text-align:center;cursor:pointer;transition:border-color .2s;}
.dp-upload-zone:hover{border-color:#BFA164;}
.dp-file-pill{display:inline-flex;align-items:center;background:var(--fm-bg3,#1E1E1E);color:#C5B898;font-size:12px;padding:4px 10px;border-radius:20px;margin:4px 2px;}

/* ---- Order summary rows ---- */
.dp-summary-row{display:flex;justify-content:space-between;align-items:center;padding:10px 0;border-bottom:1px solid var(--fm-br,#1E1E1E);font-size:14px;color:#C5B898;}
.dp-summary-row span:first-child{color:var(--fm-s,#6B6356);}

/* ---- Chip buttons (evidence type) ---- */
.dp-chip{background:var(--fm-bg3,#1E1E1E);border:1px solid #2A2A2A;border-radius:20px;padding:5px 12px;font-size:12px;font-weight:600;color:var(--fm-s,#6B6356);cursor:pointer;transition:all .2s;}
.dp-chip:hover{border-color:#BFA164;color:var(--fm-h,#F5F0E8);}
.dp-chip.active{background:rgba(191,161,100,.12);border-color:#BFA164;color:#BFA164;}

/* ---- Evidence items ---- */
.dp-ev-form{background:#0E0E0E;border:1px solid #2A2A2A;border-radius:10px;padding:14px;}
.dp-ev-item{display:flex;gap:12px;padding:12px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);}
.dp-ev-item:last-child{border-bottom:none;}
.dp-ev-dot{width:8px;height:8px;border-radius:50%;background:#BFA164;margin-top:6px;flex-shrink:0;}
.dp-ev-type{font-size:11px;font-weight:600;color:#BFA164;text-transform:uppercase;letter-spacing:.5px;}
.dp-ev-link{font-size:12px;color:#50C878;text-decoration:none;}
.dp-ev-link:hover{color:#6FFFAA;}
.dp-ev-overlay{position:absolute;top:0;left:0;right:0;bottom:0;border-radius:8px;background:rgba(0,0,0,.4);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .2s;font-size:28px;color:#fff;}
.dp-ev-overlay:hover{opacity:1;}
.dp-ev-doc-card{display:flex;align-items:center;gap:12px;background:#1A1A1A;border:1px solid #2A2A2A;border-radius:10px;padding:12px 14px;cursor:pointer;transition:border-color .2s;}
.dp-ev-doc-card:hover{border-color:#BFA164;}

/* ---- Resolve result rows ---- */
.dp-res-row{display:flex;justify-content:space-between;font-size:13px;padding:6px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);color:#C5B898;}
.dp-res-row:last-of-type{border-bottom:none;}
.dp-res-row span:first-child{color:var(--fm-s,#6B6356);}

/* ---- Toast ---- */
.dp-toast{position:fixed;bottom:24px;left:50%;transform:translateX(-50%);padding:10px 20px;border-radius:10px;font-size:13px;font-weight:600;z-index:9999;animation:dpFadeIn .3s ease;}
.dp-toast-ok{background:rgba(80,200,120,.15);color:#50C878;border:1px solid rgba(80,200,120,.3);}
.dp-toast-err{background:rgba(255,107,107,.15);color:#FF6B6B;border:1px solid rgba(255,107,107,.3);}
@keyframes dpFadeIn{from{opacity:0;transform:translateX(-50%) translateY(10px);}to{opacity:1;transform:translateX(-50%) translateY(0);}}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .dp-container { padding-top: 70px; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)); padding-left: 12px; padding-right: 12px; }
  .dp-card { padding: 12px; border-radius: 10px; }
  .dp-chip { font-size: 10px; padding: 3px 8px; }
  .dp-btn { padding: 8px 12px; font-size: 13px; }
  .dp-badge { font-size: 9px; padding: 2px 6px; }
  .dp-toast { bottom: calc(90px + env(safe-area-inset-bottom, 0px)); font-size: 12px; padding: 8px 14px; max-width: 90vw; }
}
</style>
